export default {
    baseStyle: {
        searchWrapper: {
            mb: 0
        },
        storeCount: {
            textStyle: 'bodyXsRegular',
            mb: {base: 6, lg: 12}
        },
        storeCard: {
            flex: 1,
            alignItems: 'flex-start'
        },
        storeNameRow: {
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
        },
        storeName: {
            textStyle: 'webH3'
        },
        storeDistance: {
            textStyle: 'bodyXsRegular',
            flex: '0 0 auto',
            pl: 2
        },
        storeAddress: {
            textStyle: 'bodySmRegular'
        },
        storePhone: {
            textStyle: 'bodySmRegular',
            mb: 3
        },
        storeAvailability: {
            textStyle: 'bodyXsRegular',
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            gap: 2
        },
        availabilityDot: {
            width: '6px',
            height: '6px',
            minWidth: '6px',
            minHeight: '6px',
            bg: 'webTheme.supportSuccess',
            flexShrink: 0
        },
        storeHoursToggle: {
            textStyle: 'bodyXsLink'
        },
        scheduleList: {
            my: 3,
            listStyleType: 'none'
        },
        scheduleDay: {
            textStyle: 'bodyXsBold',
            textTransform: 'capitalize'
        },
        scheduleHours: {
            textStyle: 'bodyXsRegular',
            whiteSpace: 'nowrap'
        },
        saveButton: {
            w: 'full'
        },
        noResultsContainer: {
            flexDirection: 'column',
            gap: 3,
            py: 6
        },
        noResultsTitle: {
            textStyle: 'labelXs'
        },
        noResultsDescription: {
            textStyle: 'bodyXsRegular'
        },
        postalCodeError: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            color: 'webTypo.textError'
        },
        postalCodeErrorIcon: {
            w: '13px',
            h: '13px',
            color: 'webTypo.textError',
            flexShrink: 0
        },
        skeletonList: {
            spacing: 0
        },
        skeletonRow: {
            align: 'flex-start',
            gap: 3,
            py: 4,
            borderBottomWidth: '1px',
            borderColor: 'gray.100'
        },
        skeletonRadioCircle: {
            flexShrink: 0,
            width: '18px',
            height: '18px',
            minWidth: '18px',
            borderRadius: 'full',
            borderWidth: '2px',
            borderColor: 'gray.200',
            mt: '2px'
        },
        skeletonContent: {
            flex: 1,
            spacing: 2
        },
        skeletonStoreName: {
            height: '16px',
            width: '60%'
        },
        skeletonTextMedium: {
            height: '12px',
            width: '45%'
        },
        skeletonTextShort: {
            height: '12px',
            width: '30%'
        }
    }
}
